export default __webpack_public_path__ + "static/media/biggies-logo.a1db6bc1.svg";